import { render, staticRenderFns } from "./empR.vue?vue&type=template&id=7c40c971&scoped=true&"
import script from "./empR.vue?vue&type=script&lang=js&"
export * from "./empR.vue?vue&type=script&lang=js&"
import style0 from "./empR.vue?vue&type=style&index=0&id=7c40c971&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c40c971",
  null
  
)

export default component.exports